<template>
  <div class="app flex-row align-items-center">
    <div class="container">
        <template v-if="base">
            <List v-show="list" ref="list" />
        </template>
        <Detail v-if="detail" @refresh="refresh" />
    </div>
  </div>
</template>

<script>
import List from './Notice_Test.List';
import Detail from './Notice_Test.Detail';

export default {
  components: { List, Detail},
  data: () => ({ base: false, list: false, edit: false, detail: false}),
  methods: {
    refresh() { this.$refs.list && this.$refs.list.refresh(); },
    select({ id, tag }) {
      if(!id) { 
        this.base = this.list = !(this.detail = false);
        }else { 
            this.detail = !(this.list = false);
        }
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('notice_test.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
  created() { console.log('notice_test.vue', 'created'); },
  destroyed() { console.log('notice_test.vue', 'destroyed'); },
  mounted() { console.log('notice_test.vue', 'mounted'); this.select(this.$route.params); },
}
</script>